import { CopilotFieldProposalDecision, CopilotFieldRef } from 'models/copilot/copilotField';
import { copilotPanelResultBus } from 'models/copilot/copilotPanelResultBus';
import { useEffect, useRef } from 'react';

/**
 * Delivers the text the user accepted on a Copilot proposal card to the editor that binds the field.
 * The handler is kept in a ref, so the subscription follows the field and not every render of the
 * editor.
 */
export const useCopilotFieldProposal = (
  field: CopilotFieldRef | undefined,
  onProposal: (html: string, decision: CopilotFieldProposalDecision) => void,
): void => {
  const onProposalRef = useRef(onProposal);
  onProposalRef.current = onProposal;

  const entityType = field?.entityType;
  const entityId = field?.entityId;
  const fieldName = field?.field;

  useEffect(() => {
    if (entityType === undefined || entityId === undefined || !fieldName) return;

    const subscription = copilotPanelResultBus.subscribeFieldProposal((ref, html, decision) => {
      if (ref.entityType !== entityType || ref.entityId !== entityId || ref.field !== fieldName) return;

      onProposalRef.current(html, decision);
    });

    return () => subscription.dispose();
  }, [entityType, entityId, fieldName]);
};
